<template>
    <section class="currencies">
        <div class="container">
            <h1>Сводка по криптовалютам на сегодня</h1>
            <div class="currencies-table">
                <div class="row currencies-row border-bottom">
                    <div class="col-6 col-md currencies-column m">Торговая пара</div>
                    <div class="col-6 col-md currencies-column m">Цена</div>
                    <div class="col-md currencies-column">Рынок</div>
                    <div class="col-md currencies-column">Действие</div>
                </div>
                <template v-for="(currency, index) in getMainData.currencies" :key="index">
                    <div class="row currencies-row border-bottom" v-if="currency.rate">
                        <div class="col-6 col-md currencies-column currencies-column-md m">
                            <img :src="currency.logo" :alt="currency.name">
                            <span>{{ currency.currency }}/USDT</span>
                        </div>
                        <div class="col-6 col-md currencies-column currencies-column-md m">${{ currency.rate }}</div>
                        <div class="col-md currencies-column currencies-column-md">
                            <apexchart type="area" width="120" height="40" :options="chartOptions" :series="rateFormat(currency)"></apexchart>
                        </div>
                        <div class="col-md currencies-column currencies-column-md">
                            <router-link :to="'/dashboard/buy/' + currency.currency" class="currencies-button">Купить</router-link>
                        </div>
                    </div>
                </template>
            </div>
            <div class="d-flex justify-content-center">
                <router-link to="/dashboard/buy" class="button mt-4">Подробнее</router-link>
            </div>
        </div>
    </section>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts'

export default {
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {
            chartOptions: {
                chart: {
                    toolbar: {
                        show: false
                    },
                    sparkline: {
                        enabled: true
                    },
                    parentHeightOffset: 0,
                },
                fill: {
                    type: "gradient",
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.7,
                        opacityTo: 0.9,
                        colorStops: [
                            {
                                offset: 60,
                                color: "#46E3AC",
                                opacity: 0.1
                            },
                            {
                                offset: 70,
                                color: "#46E3AC",
                                opacity: 0.08
                            },
                            {
                                offset: 100,
                                color: "transparent",
                                opacity: 1
                            }

                        ]
                    }
                },
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    show: false,
                    labels: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        show: false,
                    }
                },
                grid: {
                    show: false
                },
                stroke: {
                    width: 1,
                    colors: ["#46E3AC"],
                    curve: 'smooth',
                    // curve: ['smooth', 'straight', 'stepline']
                },
                tooltip: {
                    enabled :false
                }
            }
        }
    },
    computed: {
        getMainData() {
            return this.$store.getters.getMainData
        }
    },
    methods: {
        rateFormat(data) {
            const rates = []
            Object(data.rates).forEach((item, index) => {
                rates[index++] = item.price
            })
            return [{data: rates}]
        }
    }
}
</script>